export default "<div class=\"bar\">\n  <div class=\"progress\" [ngStyle]=\"{width: progress + '%'}\"></div>\n</div>\n"